<div class="font-dmSans">
    <app-hero />
    <app-booking-form />
    <div class="mt-20"></div>
    <app-our-rooms-section />
    <div class="mt-10"></div>
    <app-location />
</div>
